{
  "//": "Written by `bin/rails research:benchmark` from the corpus. Never edit by hand.",
  "engines": [
    "Perplexity",
    "Gemini",
    "Google AI Overviews"
  ],
  "metros": [
    "Dallas, Texas",
    "Nashville, Tennessee",
    "Boise, Idaho"
  ],
  "samples": 3,
  "post": [
    "hvac",
    "plumbing",
    "roofing",
    "electrical",
    "pest_control",
    "landscaping",
    "accounting",
    "family_law",
    "chiropractic",
    "home_care"
  ],
  "industries": [
    {
      "key": "hvac",
      "label": "HVAC / heating and cooling",
      "measured_on": "19 Sep 2026",
      "answers": 477,
      "named": {
        "count": 220,
        "of": 220
      },
      "named_per_answer": 5.8,
      "advice": {
        "count": 24,
        "of": 162
      },
      "top3_median": 22.2,
      "top3_by_brand_median": 22.2,
      "cities": [
        {
          "city": "Dallas",
          "top3": 17.8,
          "businesses": 145,
          "top3_by_brand": 17.8,
          "brands": 140,
          "leaders": [
            "rescueairandplumbing",
            "texasairzone",
            "dallasplumbingairconditioning",
            "bakerbrothersplumbingairelectric"
          ],
          "most_spellings": {
            "brand": "alphaheatingcooling",
            "names": 3
          }
        },
        {
          "city": "Nashville",
          "top3": 22.2,
          "businesses": 132,
          "top3_by_brand": 22.2,
          "brands": 124,
          "leaders": [
            "jewellmechanical",
            "hoffmannbrothers",
            "leecompany",
            "premierheatingair"
          ],
          "most_spellings": {
            "brand": "mjfrick",
            "names": 3
          }
        },
        {
          "city": "Boise",
          "top3": 29.3,
          "businesses": 89,
          "top3_by_brand": 29.3,
          "brands": 84,
          "leaders": [
            "a1heatingairconditioningelectric",
            "westernheatingairconditioning",
            "diamondheatingcoolingplumbingelectric",
            "peppyheatingcooling"
          ],
          "most_spellings": {
            "brand": "wickstromplumbingheatingcooling",
            "names": 3
          }
        }
      ],
      "repeat_overlap": 45,
      "citations": {
        "of": 6360,
        "listings": 2414,
        "business_sites": 3038
      }
    },
    {
      "key": "plumbing",
      "label": "Plumbing",
      "measured_on": "19 Sep 2026",
      "answers": 492,
      "named": {
        "count": 235,
        "of": 235
      },
      "named_per_answer": 5.2,
      "advice": {
        "count": 17,
        "of": 160
      },
      "top3_median": 18.7,
      "top3_by_brand_median": 18.7,
      "cities": [
        {
          "city": "Dallas",
          "top3": 18.7,
          "businesses": 121,
          "top3_by_brand": 18.7,
          "brands": 116,
          "leaders": [
            "bakerbrothersplumbingairelectric",
            "workmanplumbing",
            "legacyplumbing",
            "rotorooter"
          ],
          "most_spellings": {
            "brand": "rotorooter",
            "names": 4
          }
        },
        {
          "city": "Nashville",
          "top3": 18.9,
          "businesses": 124,
          "top3_by_brand": 19.1,
          "brands": 113,
          "leaders": [
            "hillerplumbingheatingcoolingelectrical",
            "hoffmannbrothers",
            "leecompany",
            "100percentplumbing"
          ],
          "most_spellings": {
            "brand": "benjaminfranklinplumbing",
            "names": 5
          }
        },
        {
          "city": "Boise",
          "top3": 17.9,
          "businesses": 88,
          "top3_by_brand": 17.9,
          "brands": 83,
          "leaders": [
            "wickstromplumbingheatingcooling",
            "hydeparkplumbing",
            "fivestarserviceprosplumbing",
            "cloverdaleplumbing"
          ],
          "most_spellings": {
            "brand": "beaconplumbingheatingairconditioningandelectrical",
            "names": 4
          }
        }
      ],
      "repeat_overlap": 45,
      "citations": {
        "of": 6124,
        "listings": 2251,
        "business_sites": 2872
      }
    },
    {
      "key": "roofing",
      "label": "Roofing",
      "measured_on": "19 Sep 2026",
      "answers": 482,
      "named": {
        "count": 224,
        "of": 224
      },
      "named_per_answer": 5.5,
      "advice": {
        "count": 21,
        "of": 161
      },
      "top3_median": 31.3,
      "top3_by_brand_median": 31.7,
      "cities": [
        {
          "city": "Dallas",
          "top3": 31.3,
          "businesses": 116,
          "top3_by_brand": 31.7,
          "brands": 114,
          "leaders": [
            "arringtonroofing",
            "newviewroofing",
            "priorityroofing",
            "bertroofing"
          ],
          "most_spellings": {
            "brand": "bertroofing",
            "names": 3
          }
        },
        {
          "city": "Nashville",
          "top3": 31.9,
          "businesses": 88,
          "top3_by_brand": 31.9,
          "brands": 75,
          "leaders": [
            "midsouthconstruction",
            "donkennedyroofing",
            "billraganroofingcompany",
            "mrgoodroof"
          ],
          "most_spellings": {
            "brand": "qualityrrc",
            "names": 9
          }
        },
        {
          "city": "Boise",
          "top3": 30.5,
          "businesses": 78,
          "top3_by_brand": 30.5,
          "brands": 76,
          "leaders": [
            "signatureroofing",
            "idahoroofingcontractors",
            "208roofing",
            "pointroofingrestoration"
          ],
          "most_spellings": {
            "brand": "ehroofing",
            "names": 3
          }
        }
      ],
      "repeat_overlap": 52,
      "citations": {
        "of": 6436,
        "listings": 1776,
        "business_sites": 3725
      }
    },
    {
      "key": "electrical",
      "label": "Electrical",
      "measured_on": "19 Sep 2026",
      "answers": 489,
      "named": {
        "count": 223,
        "of": 223
      },
      "named_per_answer": 5.4,
      "advice": {
        "count": 14,
        "of": 162
      },
      "top3_median": 26.0,
      "top3_by_brand_median": 26.0,
      "cities": [
        {
          "city": "Dallas",
          "top3": 22.8,
          "businesses": 142,
          "top3_by_brand": 23.9,
          "brands": 134,
          "leaders": [
            "electricman",
            "electricianoncall",
            "mrelectric",
            "w3electric"
          ],
          "most_spellings": {
            "brand": "mistersparky",
            "names": 4
          }
        },
        {
          "city": "Nashville",
          "top3": 26.0,
          "businesses": 135,
          "top3_by_brand": 26.0,
          "brands": 125,
          "leaders": [
            "jacobelectrician",
            "westsideelectricservice",
            "hardyelectric",
            "hoffmannbrothers"
          ],
          "most_spellings": {
            "brand": "mrelectric",
            "names": 4
          }
        },
        {
          "city": "Boise",
          "top3": 29.2,
          "businesses": 95,
          "top3_by_brand": 29.2,
          "brands": 92,
          "leaders": [
            "samedayelectric",
            "sublimeelectric",
            "all4youelectrical",
            "a1heatingairconditioningelectric"
          ],
          "most_spellings": {
            "brand": "rockymountainelectric",
            "names": 3
          }
        }
      ],
      "repeat_overlap": 50,
      "citations": {
        "of": 6294,
        "listings": 2458,
        "business_sites": 2793
      }
    },
    {
      "key": "pest_control",
      "label": "Pest control",
      "measured_on": "12 Oct 2026",
      "answers": 500,
      "named": {
        "count": 237,
        "of": 237
      },
      "named_per_answer": 5.6,
      "advice": {
        "count": 31,
        "of": 157
      },
      "top3_median": 20.9,
      "top3_by_brand_median": 23.7,
      "cities": [
        {
          "city": "Dallas",
          "top3": 20.9,
          "businesses": 132,
          "top3_by_brand": 23.7,
          "brands": 120,
          "leaders": [
            "terminix",
            "orkin",
            "abchomecommercialservices",
            "ecosafepestcontrol"
          ],
          "most_spellings": {
            "brand": "abchomecommercialservices",
            "names": 5
          }
        },
        {
          "city": "Nashville",
          "top3": 23.8,
          "businesses": 123,
          "top3_by_brand": 25.2,
          "brands": 114,
          "leaders": [
            "allamericanpestcontrol",
            "uspestprotection",
            "terminix",
            "orkin"
          ],
          "most_spellings": {
            "brand": "allpestsolutions",
            "names": 5
          }
        },
        {
          "city": "Boise",
          "top3": 19.0,
          "businesses": 106,
          "top3_by_brand": 19.1,
          "brands": 98,
          "leaders": [
            "boisepestcontrol",
            "cascadepestcontrol",
            "pestcompestmanagement",
            "vertexpestcontrol"
          ],
          "most_spellings": {
            "brand": "terminix",
            "names": 5
          }
        }
      ],
      "repeat_overlap": 46,
      "citations": {
        "of": 5058,
        "listings": 1719,
        "business_sites": 2748
      }
    },
    {
      "key": "landscaping",
      "label": "Landscaping / lawn care",
      "measured_on": "12 Oct 2026",
      "answers": 478,
      "named": {
        "count": 222,
        "of": 226
      },
      "named_per_answer": 5.7,
      "advice": {
        "count": 13,
        "of": 160
      },
      "top3_median": 11.1,
      "top3_by_brand_median": 12.9,
      "cities": [
        {
          "city": "Dallas",
          "top3": 13.5,
          "businesses": 163,
          "top3_by_brand": 13.5,
          "brands": 153,
          "leaders": [
            "southernbotanical",
            "keanelandscaping",
            "alterralandscapedesign",
            "greenpal"
          ],
          "most_spellings": {
            "brand": "lawnstarter",
            "names": 3
          }
        },
        {
          "city": "Nashville",
          "top3": 11.1,
          "businesses": 164,
          "top3_by_brand": 12.9,
          "brands": 141,
          "leaders": [
            "lawnstarter",
            "gardensofbabylonlandscapes",
            "greenpal",
            "pureturf"
          ],
          "most_spellings": {
            "brand": "weedman",
            "names": 5
          }
        },
        {
          "city": "Boise",
          "top3": 10.0,
          "businesses": 166,
          "top3_by_brand": 11.0,
          "brands": 150,
          "leaders": [
            "lawndoctor",
            "boiselandscapedesign",
            "allprolawnservice",
            "chamberlainsonslandscaping"
          ],
          "most_spellings": {
            "brand": "weedman",
            "names": 4
          }
        }
      ],
      "repeat_overlap": 44,
      "citations": {
        "of": 4502,
        "listings": 1679,
        "business_sites": 2237
      }
    },
    {
      "key": "accounting",
      "label": "Accounting / tax preparation",
      "measured_on": "12 Oct 2026",
      "answers": 494,
      "named": {
        "count": 219,
        "of": 225
      },
      "named_per_answer": 5.7,
      "advice": {
        "count": 12,
        "of": 162
      },
      "top3_median": 11.3,
      "top3_by_brand_median": 12.9,
      "cities": [
        {
          "city": "Dallas",
          "top3": 10.1,
          "businesses": 214,
          "top3_by_brand": 11.1,
          "brands": 204,
          "leaders": [
            "hayniecompany",
            "lanegormantrubitt",
            "whitleypenn",
            "darkhorsecpas"
          ],
          "most_spellings": {
            "brand": "lanegormantrubitt",
            "names": 3
          }
        },
        {
          "city": "Nashville",
          "top3": 11.3,
          "businesses": 175,
          "top3_by_brand": 13.8,
          "brands": 157,
          "leaders": [
            "darkhorsecpas",
            "blankenshipcpagroup",
            "hrblock",
            "kraftcpas"
          ],
          "most_spellings": {
            "brand": "darkhorsecpas",
            "names": 7
          }
        },
        {
          "city": "Boise",
          "top3": 12.2,
          "businesses": 160,
          "top3_by_brand": 12.9,
          "brands": 137,
          "leaders": [
            "jtccpas",
            "hrblock",
            "idahotaxbookkeepingservices",
            "jacksonhewitt"
          ],
          "most_spellings": {
            "brand": "harriscpas",
            "names": 7
          }
        }
      ],
      "repeat_overlap": 41,
      "citations": {
        "of": 4413,
        "listings": 1723,
        "business_sites": 2162
      }
    },
    {
      "key": "family_law",
      "label": "Family law / divorce",
      "measured_on": "12 Oct 2026",
      "answers": 496,
      "named": {
        "count": 209,
        "of": 229
      },
      "named_per_answer": 5.0,
      "advice": {
        "count": 5,
        "of": 160
      },
      "top3_median": 23.6,
      "top3_by_brand_median": 24.3,
      "cities": [
        {
          "city": "Dallas",
          "top3": 23.6,
          "businesses": 115,
          "top3_by_brand": 24.3,
          "brands": 103,
          "leaders": [
            "hargravefamilylaw",
            "goransonbainausley",
            "mcclurelawgroup",
            "orsingernelsondowningandersonllp"
          ],
          "most_spellings": {
            "brand": "orsingernelsondowningandersonllp",
            "names": 6
          }
        },
        {
          "city": "Nashville",
          "top3": 25.1,
          "businesses": 118,
          "top3_by_brand": 25.1,
          "brands": 114,
          "leaders": [
            "millerupshawfamilylaw",
            "widriglaw",
            "rogerssheaspanos",
            "colelawgroup"
          ],
          "most_spellings": {
            "brand": "widriglaw",
            "names": 3
          }
        },
        {
          "city": "Boise",
          "top3": 21.9,
          "businesses": 101,
          "top3_by_brand": 21.9,
          "brands": 97,
          "leaders": [
            "joneslawpartners",
            "schoettgerfabreguettelawoffice",
            "kmitchelllaw",
            "coshohumphreyllp"
          ],
          "most_spellings": {
            "brand": "taylorlawmediation",
            "names": 3
          }
        }
      ],
      "repeat_overlap": 51,
      "citations": {
        "of": 4631,
        "listings": 1986,
        "business_sites": 2294
      }
    },
    {
      "key": "chiropractic",
      "label": "Chiropractic",
      "measured_on": "12 Oct 2026",
      "answers": 482,
      "named": {
        "count": 218,
        "of": 219
      },
      "named_per_answer": 5.2,
      "advice": {
        "count": 45,
        "of": 161
      },
      "top3_median": 19.5,
      "top3_by_brand_median": 19.9,
      "cities": [
        {
          "city": "Dallas",
          "top3": 13.9,
          "businesses": 135,
          "top3_by_brand": 15.1,
          "brands": 126,
          "leaders": [
            "apexchiropractic",
            "uptownchiropractic",
            "woodwardchiropractic",
            "expressionschiropractic"
          ],
          "most_spellings": {
            "brand": "expressionschiropractic",
            "names": 4
          }
        },
        {
          "city": "Nashville",
          "top3": 30.4,
          "businesses": 111,
          "top3_by_brand": 31.9,
          "brands": 94,
          "leaders": [
            "sweeneychiropractic",
            "actionspinejoint",
            "dohnalchiropractic",
            "jointchiropractic"
          ],
          "most_spellings": {
            "brand": "uppercervicalspinecenter",
            "names": 5
          }
        },
        {
          "city": "Boise",
          "top3": 19.5,
          "businesses": 126,
          "top3_by_brand": 19.9,
          "brands": 115,
          "leaders": [
            "thrivechiropractic",
            "wellnesscenter",
            "balancechiropracticclinic",
            "modernchiropracticcenter"
          ],
          "most_spellings": {
            "brand": "wellnesscenter",
            "names": 3
          }
        }
      ],
      "repeat_overlap": 50,
      "citations": {
        "of": 4929,
        "listings": 896,
        "business_sites": 2818
      }
    },
    {
      "key": "home_care",
      "label": "In-home senior care",
      "measured_on": "12 Oct 2026",
      "answers": 492,
      "named": {
        "count": 233,
        "of": 234
      },
      "named_per_answer": 6.1,
      "advice": {
        "count": 31,
        "of": 160
      },
      "top3_median": 13.0,
      "top3_by_brand_median": 25.8,
      "cities": [
        {
          "city": "Dallas",
          "top3": 12.3,
          "businesses": 191,
          "top3_by_brand": 23.2,
          "brands": 130,
          "leaders": [
            "homeinstead",
            "rightathome",
            "visitingangels",
            "seniorhelpers"
          ],
          "most_spellings": {
            "brand": "visitingangels",
            "names": 12
          }
        },
        {
          "city": "Nashville",
          "top3": 13.0,
          "businesses": 173,
          "top3_by_brand": 26.4,
          "brands": 116,
          "leaders": [
            "visitingangels",
            "comfortkeepers",
            "rightathome",
            "homeinstead"
          ],
          "most_spellings": {
            "brand": "visitingangels",
            "names": 11
          }
        },
        {
          "city": "Boise",
          "top3": 14.0,
          "businesses": 147,
          "top3_by_brand": 25.8,
          "brands": 92,
          "leaders": [
            "visitingangels",
            "comfortkeepers",
            "homeinstead",
            "homewatchcaregivers"
          ],
          "most_spellings": {
            "brand": "seniorhelpers",
            "names": 10
          }
        }
      ],
      "repeat_overlap": 34,
      "citations": {
        "of": 5091,
        "listings": 1987,
        "business_sites": 2755
      }
    },
    {
      "key": "med_spa",
      "label": "Med spa / aesthetics",
      "measured_on": "19 Sep 2026",
      "answers": 468,
      "named": {
        "count": 211,
        "of": 211
      },
      "named_per_answer": 6.0,
      "advice": {
        "count": 40,
        "of": 161
      },
      "top3_median": 17.2,
      "top3_by_brand_median": 18.7,
      "cities": [
        {
          "city": "Dallas",
          "top3": 17.2,
          "businesses": 164,
          "top3_by_brand": 18.7,
          "brands": 128,
          "leaders": [
            "vivadayspamedspa",
            "sanjivamedicalspa",
            "itsasecretmedspa",
            "marasmedspa"
          ],
          "most_spellings": {
            "brand": "vivadayspamedspa",
            "names": 4
          }
        },
        {
          "city": "Nashville",
          "top3": 15.6,
          "businesses": 148,
          "top3_by_brand": 17.1,
          "brands": 133,
          "leaders": [
            "elamar",
            "skinpharm",
            "canvasskin",
            "61fivehealthwellness"
          ],
          "most_spellings": {
            "brand": "toxxology",
            "names": 3
          }
        },
        {
          "city": "Boise",
          "top3": 25.3,
          "businesses": 98,
          "top3_by_brand": 27.3,
          "brands": 90,
          "leaders": [
            "bobbibullockmedicalesthetics",
            "boiseimageenhancementcentre",
            "renumedispa",
            "spa35"
          ],
          "most_spellings": {
            "brand": "bobbibullockmedicalesthetics",
            "names": 4
          }
        }
      ],
      "repeat_overlap": 46,
      "citations": {
        "of": 6715,
        "listings": 2110,
        "business_sites": 3639
      }
    },
    {
      "key": "pi_law",
      "label": "Personal injury law",
      "measured_on": "19 Sep 2026",
      "answers": 484,
      "named": {
        "count": 208,
        "of": 224
      },
      "named_per_answer": 5.2,
      "advice": {
        "count": 13,
        "of": 158
      },
      "top3_median": 25.3,
      "top3_by_brand_median": 25.3,
      "cities": [
        {
          "city": "Dallas",
          "top3": 18.9,
          "businesses": 137,
          "top3_by_brand": 18.9,
          "brands": 134,
          "leaders": [
            "mullenmullenlawfirm",
            "hamiltonwingollp",
            "lyonssimmonsllp",
            "thompsonlaw"
          ],
          "most_spellings": {
            "brand": "rasanskylawfirm",
            "names": 2
          }
        },
        {
          "city": "Nashville",
          "top3": 32.6,
          "businesses": 97,
          "top3_by_brand": 32.6,
          "brands": 94,
          "leaders": [
            "kinnardlaw",
            "rockymcelhaneylawfirm",
            "matthardinlaw",
            "lawofficesofjohndaypc"
          ],
          "most_spellings": {
            "brand": "morganmorgan",
            "names": 3
          }
        },
        {
          "city": "Boise",
          "top3": 25.3,
          "businesses": 108,
          "top3_by_brand": 25.3,
          "brands": 105,
          "leaders": [
            "hepworthholzerllp",
            "litsterfrostinjurylawyers",
            "lawofficesofmatthewggunn",
            "hepworthholzer"
          ],
          "most_spellings": {
            "brand": "smithhorraspa",
            "names": 3
          }
        }
      ],
      "repeat_overlap": 44,
      "citations": {
        "of": 6042,
        "listings": 1894,
        "business_sites": 3864
      }
    },
    {
      "key": "dental",
      "label": "Dental / DSO",
      "measured_on": "19 Sep 2026",
      "answers": 466,
      "named": {
        "count": 206,
        "of": 206
      },
      "named_per_answer": 5.4,
      "advice": {
        "count": 46,
        "of": 162
      },
      "top3_median": 12.0,
      "top3_by_brand_median": 12.0,
      "cities": [
        {
          "city": "Dallas",
          "top3": 12.0,
          "businesses": 176,
          "top3_by_brand": 12.0,
          "brands": 161,
          "leaders": [
            "highlandparkorthodontics",
            "dallaslaserdentistry",
            "artsfamilydentistry",
            "cockrellhilldental"
          ],
          "most_spellings": {
            "brand": "mintdentistry",
            "names": 4
          }
        },
        {
          "city": "Nashville",
          "top3": 11.8,
          "businesses": 175,
          "top3_by_brand": 11.8,
          "brands": 168,
          "leaders": [
            "elevationorthodontics",
            "gluckorthodontics",
            "gulchdentalstudio",
            "dentistryofnashville"
          ],
          "most_spellings": {
            "brand": "metropublichealthdepartment",
            "names": 3
          }
        },
        {
          "city": "Boise",
          "top3": 12.2,
          "businesses": 150,
          "top3_by_brand": 12.2,
          "brands": 145,
          "leaders": [
            "northwestdentalcenter",
            "alexanderhoffmanorthodontics",
            "boisefamilydentalcare",
            "slatteryorthodontics"
          ],
          "most_spellings": {
            "brand": "treasurevalleypediatricdentistry",
            "names": 2
          }
        }
      ],
      "repeat_overlap": 46,
      "citations": {
        "of": 6138,
        "listings": 1612,
        "business_sites": 3864
      }
    }
  ]
}
